module.exports = __webpack_public_path__ + "img/plate_plan_4.560398b2.jpg";